import { scoreChipClass } from '@/utils/scoring';

interface ScoreChipProps {
  score: number | null;
}

export function ScoreChip({ score }: ScoreChipProps) {
  const cls = scoreChipClass(score);
  return (
    <span className={`text-xs font-mono px-2 py-0.5 rounded-full border min-w-[62px] text-center inline-block ${cls}`}>
      {score != null ? String(Math.round(score)) : '—'}
    </span>
  );
}
